import { HttpClient } from '@angular/common/http';
import { Injector } from '@angular/core';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { unwrapNewApiEnvelope } from './new-api-envelope.util';
import { NewApiDataService } from './new-api-data.service';
import { AreaImageAdminDto } from '../models/area-v2-area-image.dto';

@Injectable({ providedIn: 'root' })
export class AreaV2AreaImageApiService extends NewApiDataService {
  private readonly _baseUrl = environment.newApiBackend;
  constructor(
    private readonly _http: HttpClient,
    injector: Injector,
    store: Store<any>,
  ) {
    super(injector, store);
  }

  listActiveImages(): Observable<AreaImageAdminDto[]> {
    return this.withLoading(
      () =>
        this._http
          .get<unknown>(`${this._baseUrl}/api/area-image/admin/all`)
          .pipe(map((res) => unwrapNewApiEnvelope<AreaImageAdminDto[]>(res))),
      { toastOnError: false },
    );
  }
}

